import { Client, GetInteractionContainerResponse } from "../../../api/Client";
import { appConfig } from "../../../appConfig";

export const fetchInteraction = async (interactionId: number): Promise<GetInteractionContainerResponse> => {
  const client = new Client(appConfig.REACT_APP_LCMS_API_URL);

  const interactionContainer = await client.interactionComponentGet(interactionId, undefined);
  return interactionContainer;
};
